import RegulatoryContainer from "@/components/business/RegulatoryContainer/RegulatoryContainer";
import { useChangeBackgroundColor } from "@hooks/useChangeBackgroundColor";
import { theme } from "@styles/theme";
import { removeDealTypeDisplayName } from "@utils/returnDealTypeDisplayName/returnDealTypeDisplayName";

const RegulatoryListPage = () => {
  useChangeBackgroundColor(theme.color.neural.gray00);

  removeDealTypeDisplayName();

  return <RegulatoryContainer />;
};

export default RegulatoryListPage;
